import AdminLoginPage from '../components/AdminLoginPage';

function Login() {
  return <AdminLoginPage />;
}

export default Login;
